<template>
  <footer class="footer">
    <b-container class="mb-5 mb-md-0">
      <b-row>
        <b-col cols="12" md="10">
          <b-container class="footer-block">
            <b-row>
              <b-col class="mb-4 pl-4">
                <h5 class="footer-block-header">Realização</h5>
              </b-col>
            </b-row>
            <b-row class="align-items-center footer__logos-wrapper">
              <b-col cols="6" md="" class="mb-5 mb-md-0">
                <a href="https://saude.rs.gov.br" target="_blank">
                  <img
                    class="footer__logo-img footer__logo-img--secretaria"
                    src="@img/footer/logo-secretaria-da-saude.svg"
                    alt="Secretaria de Saúde do RS">
                </a>
              </b-col>
              <b-col cols="6" md="" class="mb-5 mb-md-0">
                <a href="https://www.ufrgs.br/telessauders" target="_blank">
                  <img
                    class="footer__logo-img footer__logo-img--telessaude"
                    src="@img/footer/logo-telessaude.svg"
                    alt="Telessaúde RS">
                </a>
              </b-col>
              <b-col cols="6" md="" class="mb-5 mb-md-0">
                <a href="http://www.ufrgs.br" target="_blank">
                  <img
                    class="footer__logo-img footer__logo-img--ufrgs"
                    src="@img/footer/logo-ufrgs.svg"
                    alt="UFRGS">
                </a>
              </b-col>
              <b-col cols="6" md="" class="mb-5 mb-md-0">
                <a href="https://www.portalfaurgs.com.br" target="_blank">
                  <img
                    class="footer__logo-img footer__logo-img--faurgs"
                    src="@img/footer/logo-faurgs.svg"
                    alt="FAURGS">
                </a>
              </b-col>
              <b-col cols="6" md="" class="">
                <a href="https://www.cosemsrs.org.br" target="_blank">
                  <img
                    class="footer__logo-img footer__logo-img--cosems"
                    src="@img/footer/logo-cosems-rs.png"
                    alt="cosems RS">
                </a>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="12" md="2" class="mt-5 pt-5 mt-md-0 pt-md-0">
          <b-container class="footer-block apoio">
            <b-row>
              <b-col class="mb-4 pl-4">
                <h5 class="footer-block-header">Apoio</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" md="12" class="mt-md-4 mb-md-3 mb-lg-4">
                <a href="https://www.amrigs.org.br" target="_blank">
                  <img
                    class="footer__logo-img footer__logo-img--amrigs"
                    src="@img/footer/logo-amrigs.png"
                    alt="AMRIGS">
                </a>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
};
</script>

<style lang="scss" scoped>
$footer-background: $footer-background-color;
$footer-text-color: $text-color--light;
.footer {
  padding: 1.5rem 0;
  background-color: $footer-background;
  color: $footer-text-color;
}
.footer-block {
  border-left: 1px solid;
}
.footer__logo-img {
  display: block;
  margin: 0 auto;
}
.footer__logo-img--secretaria {
  max-height: 80px;
}
.footer__logo-img--telessaude {
  max-height: 54px;
}
.footer__logo-img--ufrgs {
  max-height: 44px;
}
.footer__logo-img--faurgs {
  max-height: 34px;
}
.footer__logo-img--cosems {
  max-height: 32px;
}
.footer__logo-img--amrigs {
  max-height: 40px;
}

@include media-breakpoint-up(md) {
  .footer {
    padding: 1.75rem 0;
  }
}

@include media-breakpoint-up(lg) {
  .footer {
    padding: 1.75rem 0;
  }
  .footer__logo-img--secretaria {
    max-height: 100px;
  }
  .footer__logo-img--cosems {
    max-height: 40px;
  }
}
</style>
